import { atom } from 'recoil'
import { IMDMUnitInstance } from '@/pages/MDM/mdm.types.ts'

interface IMDMUnitInstancesAtomState {
  items: IMDMUnitInstance[]
}

const unitInstancesAtom = atom<IMDMUnitInstancesAtomState>({
  key: '/mdm/unit-instances',
  default: {
    items: [],
  },
})
export default unitInstancesAtom
